import { Button } from '@/components/ui/button'
import { supabase } from '@/integrations/supabase/client'
import { toast } from 'sonner'

export const TestEmailButton = () => {
  const handleSendTestEmails = async () => {
    console.log("Starting test email send...");
    try {
      const response = await supabase.functions.invoke('send-status-change-email', {
        body: {
          orderId: 'TEST-001',
          oldStatus: 'pending',
          newStatus: 'approved',
          isTestEmail: true
        }
      })
      
      console.log("Full response:", response);
      
      if (response.error) {
        console.error('Test email error:', response.error)
        toast.error(`Failed to send test emails: ${response.error.message}`)
      } else {
        console.log('Test emails sent successfully:', response.data)
        if (response.data.success) {
          toast.success('Test emails sent to yogabalaji@gmail.com and goajailbay@gmail.com')
        } else {
          toast.error('Email function worked but emails may have failed')
        }
      }
    } catch (error) {
      console.error('Error sending test emails:', error)
      toast.error(`Error sending test emails: ${error}`)
    }
  }

  return (
    <Button onClick={handleSendTestEmails} variant="outline">
      Send Test Emails
    </Button>
  )
}